import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from 'view/common/with-async';

export const ChangeBoardingSingleSpotlight = withAsync({
    loader: lazyForPaint(
        () => import(/* webpackChunkName: "change-boarding-single-spotlight" */ './change-boarding-single-spotlight')
    ),
    LoadingSkeleton: () => null,
});
